import React, { FunctionComponent, ReactNode } from 'react'

import { ButtonToolbar } from 'rsuite'

import styled from 'styled-components'

import { baseColors, Button, TickCircleFilled } from '@fairhq/common'

import { LinkButton } from '../../styled'
import { Message } from '../../styled/message'

import { MessageBoxContainer } from './styled'

const SuccessIcon = styled(TickCircleFilled)`
  margin-left: -50px;
  margin-top: 20px;
  position: absolute;
`

interface MessageBoxProps {
  description?: ReactNode
  btnLabel?: string
  cancelBtnLabel?: string
  icon?: string
  note?: string
  onCancel?: () => void
  onClick?: () => void
  title?: string
  loading?: boolean
  success?: boolean
  disabled?: boolean
  before?: boolean
  children?: React.ReactNode
}

const MessageBox: FunctionComponent<MessageBoxProps> = ({
  btnLabel,
  cancelBtnLabel,
  children,
  description,
  icon,
  note,
  onClick,
  onCancel,
  title,
  loading,
  success,
  disabled,
  before,
}) => (
  <MessageBoxContainer>
    {icon ? (
      <div style={{ textAlign: 'center' }}>
        <img src={icon} alt={title} height="200" />
        {success ? (
          <SuccessIcon width="60px" height="60px" outline={baseColors.green} />
        ) : undefined}
      </div>
    ) : undefined}
    {title ? <h3>{title}</h3> : undefined}
    {before && description ? <Message>{description}</Message> : undefined}
    {children}
    {!before && description ? <Message>{description}</Message> : undefined}
    <ButtonToolbar
      style={{ justifyContent: cancelBtnLabel ? 'space-between' : 'center' }}
    >
      {cancelBtnLabel ? (
        <LinkButton onClick={onCancel} disabled={!onCancel}>
          {cancelBtnLabel}
        </LinkButton>
      ) : undefined}
      {btnLabel ? (
        <Button
          onClick={onClick}
          loading={loading}
          disabled={!onClick || loading || disabled}
        >
          {btnLabel}
        </Button>
      ) : undefined}
    </ButtonToolbar>
    {note ? <Message type="indication">{note}</Message> : undefined}
  </MessageBoxContainer>
)

export default MessageBox
